import { toast } from "../toast"

/**
 * Creates a toast, a small notification for conveying a message to the user.
 */
export default function useToast() {
  return toast
}
